export default __webpack_public_path__ + "static/imda2018top9-58e1bafb579924ab7a2cdc627387f14e.jpg";